module.exports = __webpack_public_path__ + "static/media/dk.dd036ffe.svg";